import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealApiResponse } from "@zeal/common";
import {
  TCreateLaborPosterVersionRequestSchema,
  TCreateLaborPosterVersionResponseSchema,
} from "./createLaborPosterVersion.schema";

const LABOR_POSTER_UPLOAD_TIMEOUT_MS = 180000;

export const createLaborPosterVersion = (axios: IAxiosInstance) => {
  return async (data: TCreateLaborPosterVersionRequestSchema) => {
    const { labor_poster_id, ...params } = data;
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    const response = await axios.noRetry.post<
      ZealApiResponse<TCreateLaborPosterVersionResponseSchema>
    >(`/labor-posters/${labor_poster_id}/versions`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: LABOR_POSTER_UPLOAD_TIMEOUT_MS,
    });
    return response.data;
  };
};
